import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersExecutedDone(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.ordersExecutedDone}
      subtitle={texts.ordersExecutedDoneTooltip}
    >
      <Row
        onClick={onSelect}
        text={texts.ordersExecutedDone}
        value={count}
        disabled={count === 0}
        testId="plan-summary-executed-done-orders"
      />
    </Tooltip>
  )
}
